import React, { useEffect, useRef, useState } from "react";
import { 
    getPendingOnLeaves, 
    getOnLeaveTimeline,
    approveOnLeave,
    rejectOnLeave,
} from "../../../api/hrm/on_leaves/onLeave";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCalendar, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import defaultAvatar from '../../../assets/images/avatar/employee-1.png';
import { motion, AnimatePresence } from "framer-motion";
import { showWarningToast } from "../../../components/ConfirmDialog";
import { formatDateVN } from "../../../utils/formatUtils";

export default function PendingOnLeaveListNew({
  data = [],
  currentUserId,
  autoOpenId = null,
  onAutoOpened,
}) {
//   const [list, setList] = useState([]);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [note, setNote] = useState("");
  const autoOpenedRef = useRef(null);
  
  // ================================
  // POPUP DETAIL + TIMELINE
  // ================================
  const openDetail = async (item) => {
    // console.log("📌 OPEN DETAIL:", item);
    // console.log("👉 Next Approver ID:", item.next_approver_id);
    // console.log("👉 Current User ID:", currentUserId);
    // console.log("👉 Can Approve:", item.next_approver_id === currentUserId);
  
    setSelectedLeave(item);
  
    try {
        // console.log("📡 Gọi API timeline → getOnLeaveTimeline:", item.id);
      
        const rs = await getOnLeaveTimeline(item.id);
        // console.log("📩 Timeline API response:", rs);
      
        // FIX: Lấy đúng field timeline
        const timelineData =
          Array.isArray(rs.timeline) ? rs.timeline :
          Array.isArray(rs.data) ? rs.data :
          [];
      
        // console.log("🎯 Timeline parsed:", timelineData);
      
        setTimeline(timelineData);
    } catch (e) {
        console.error("❌ Lỗi load timeline:", e);
    }
  };

  const closeModal = () => {
    setSelectedLeave(null);
    setNote("");
    setTimeline([]);
  };

  // ================================
  // HANDLE APPROVE / REJECT
  // ================================
  const canApprove = selectedLeave
    ? selectedLeave.next_approver_id === currentUserId
    : false;

    const handleApprove = async () => {
        try {
          if (!selectedLeave) return;
      
          const payload = {
            approver_id: currentUserId,     // 🔥 CHỈ GỬI STRING – KHÔNG LỒNG OBJECT
            approval_note: note || null,
          };
      
        //   console.log("📤 Approve payload gửi lên:", payload);
      
          const res = await approveOnLeave(selectedLeave.id, payload);
      
        //   console.log("✔ Approve API success:", res.data);
      
          closeModal();
          window?.onReloadLeaveList?.();
        } catch (e) {
          console.error("❌ Lỗi duyệt:", e);
        }
    };
      
    const handleReject = async () => {
        try {
      
          // 🚨 BẮT BUỘC NHẬP LÝ DO TRƯỚC KHI TỪ CHỐI
          if (!note || note.trim() === "") {
            showWarningToast("Vui lòng nhập lý do từ chối trước khi tiếp tục.");
            return;
          }
      
          await rejectOnLeave(selectedLeave.id, {
            approver_id: currentUserId,
            approval_note: note.trim(),
          });
      
          closeModal();
          window?.onReloadLeaveList?.();
      
        } catch (e) {
          console.error("❌ Lỗi từ chối:", e);
        }
    };
  
  useEffect(() => {
    if (!autoOpenId || autoOpenedRef.current === autoOpenId) return;
    const targetLeave = data.find((item) => String(item.id) === String(autoOpenId));
    if (!targetLeave) return;

    autoOpenedRef.current = autoOpenId;
    openDetail(targetLeave);
    onAutoOpened?.(targetLeave);
  }, [autoOpenId, data]);


    return (
        <>
        <h3 className="font-semibold text-base text-gray-700 mb-3 ml-2">
            Danh sách nghỉ phép chờ duyệt ({data.length} phiếu)
        </h3>

        {/* =========================== */}
        {/* CARD LIST - style đồng bộ PendingOvertimeList */}
        {/* =========================== */}
      <div className="grid grid-cols-1 mb:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
        {data.map((item) => {
            const showNeedApprove = item.next_approver_id === currentUserId;
            const avatarUrl = item.employee_avatar || defaultAvatar;
            const statusLabel = showNeedApprove ? "Cần duyệt" : "Chờ duyệt";
            const leaveTypeClass =
              item.leave_type === "Phép năm"
                ? "bg-blue-100 text-blue-700 border-blue-200"
                : item.leave_type === "Bảo hiểm xã hội"
                ? "bg-green-100 text-green-700 border-green-200"
                : "bg-red-100 text-red-700 border-red-200";

            return (
            <div
                key={item.id}
                onClick={() => openDetail(item)}
                className="group relative bg-white rounded-[1.8rem] p-4 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300 cursor-pointer overflow-hidden"
            >
                {/* Tag trạng thái */}
                <div
                  className={`absolute top-0 right-0 px-3 py-1 text-[9px] font-black uppercase tracking-widest rounded-bl-xl shadow-sm ${
                    showNeedApprove
                      ? "bg-red-600 text-white"
                      : "bg-slate-100 text-slate-400"
                  }`}
                >
                  {statusLabel}
                </div>

                {/* Header: Avatar + thông tin nhân viên */}
                <div className="flex gap-3 items-center mb-3">
                <div className="relative shrink-0">
                <img
                    src={avatarUrl}
                    alt="avatar"
                    className="w-10 h-10 rounded-xl object-cover border border-gray-50 shadow-sm group-hover:scale-105 transition-transform"
                />
                <div
                  className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white ${
                    showNeedApprove ? "bg-red-500 animate-pulse" : "bg-amber-400"
                  }`}
                />
                </div>
                <div>
                    <p className="font-black text-gray-800 text-[13px] leading-tight truncate uppercase tracking-tight">
                      {item.employee_name}
                    </p>
                    <p className="text-[10px] font-bold text-gray-400 italic truncate mt-0.5">
                    {item.branch_name} • {item.department_name}
                    </p>
                </div>
                </div>

                {/* Loại phép + số ngày */}
                <div className="flex items-center justify-between mb-3 pt-3 border-t border-gray-50">
                {item.leave_type && (
                    <span
                    className={`px-2 py-0.5 text-[9px] font-black rounded-lg border uppercase tracking-widest shrink-0 ${leaveTypeClass}`}
                    >
                    {item.leave_type}
                    </span>
                )}

                {item.total_days && (
                    <span className="px-2 py-0.5 text-[9px] font-black rounded-lg bg-amber-50 text-amber-600 border border-amber-100 uppercase tracking-widest">
                    {item.total_days} ngày
                    </span>
                )}
                </div>

                {/* Thời gian nghỉ */}
                <div className="flex items-center text-[11px] font-bold text-gray-600 gap-2 mb-3">
                <div className="w-5 h-5 rounded-md bg-slate-50 flex items-center justify-center text-slate-400">
                  <FontAwesomeIcon icon={faCalendar} className="text-[9px]" />
                </div>
                <span className="font-black tracking-tighter">
                  {formatDateVN(item.from_date)} — {formatDateVN(item.to_date)}
                </span>
                </div>

                {/* Lý do nghỉ phép */}
                <div className="p-2.5 bg-gray-50/80 rounded-xl border border-gray-100/50 group-hover:bg-white group-hover:border-red-100 transition-colors">
                  <p className="text-[11px] text-gray-500 line-clamp-2 leading-relaxed italic font-medium">
                    "{item.reason || "Không có ghi chú"}"
                  </p>
                </div>
            </div>
            );
        })}
        </div>


        {/* =========================== */}
        {/* POPUP DETAIL */}
        {/* =========================== */}
        <AnimatePresence>
            {selectedLeave && (
            <motion.div
                className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[999]"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                onClick={closeModal}
            >
                <motion.div
                className="relative bg-white w-full max-w-xl rounded-[1.75rem] sm:rounded-[2.3rem] shadow-2xl border border-slate-100 max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] flex flex-col overflow-hidden"
                initial={{ opacity: 0, scale: 0.95, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95, y: 20 }}
                transition={{ duration: 0.22, ease: "easeOut" }}
                onClick={(e) => e.stopPropagation()}
                >
                <div className="p-4 sm:p-8 pb-0 flex items-start sm:items-center justify-between gap-3 shrink-0">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center border border-red-100 shadow-sm">
                      <FontAwesomeIcon icon={faCalendar} className="text-lg" />
                    </div>
                    <div>
                      <h3 className="text-base sm:text-xl font-black uppercase tracking-tight text-gray-800 leading-tight">
                        Chi tiết đơn nghỉ phép
                      </h3>
                      <p className="text-[9px] sm:text-[10px] font-black text-gray-400 uppercase tracking-widest mt-0.5 italic">
                        Quy trình xét duyệt phiếu nghỉ IMA
                      </p>
                    </div>
                  </div>

                  <button
                    onClick={closeModal}
                    className="p-2.5 bg-gray-50 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-2xl transition-all border border-gray-100"
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>

                <div className="flex-1 overflow-y-auto px-4 sm:px-8 py-5 space-y-5 min-h-0">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 p-4 bg-slate-50 rounded-3xl border border-slate-100">
                    <img
                      src={selectedLeave.employee_avatar || defaultAvatar}
                      className="w-14 h-14 sm:w-16 sm:h-16 rounded-[1.25rem] sm:rounded-[1.5rem] object-cover border-2 border-white shadow-md shrink-0"
                      alt="avatar"
                    />
                    <div className="flex-1 min-w-0">
                      <h4 className="text-base sm:text-lg font-black text-gray-800 uppercase tracking-tight break-words leading-tight">
                        {selectedLeave.employee_name}
                      </h4>
                      <p className="text-[10px] sm:text-[11px] font-bold text-gray-400 uppercase tracking-widest mt-1 break-words">
                        {selectedLeave.branch_name} • {selectedLeave.department_name}
                      </p>
                      <div className="mt-2 inline-flex max-w-full items-center gap-1.5 px-3 py-1 rounded-lg bg-white border border-slate-100 shadow-sm">
                        <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />
                        <span className="text-[9px] font-black text-slate-600 uppercase tracking-widest break-words">
                          {canApprove ? "Bạn là người duyệt hiện tại" : "Chờ duyệt cấp hiện tại"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-3">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-white border border-gray-50 rounded-2xl">
                      <div className="flex items-center gap-3 min-w-0">
                        <div className="p-2 rounded-xl bg-blue-50 text-blue-600">
                          <FontAwesomeIcon icon={faCalendar} />
                        </div>
                        <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                          Thời gian nghỉ
                        </span>
                      </div>
                      <span className="text-sm font-black text-gray-700 sm:text-right break-words">
                        {formatDateVN(selectedLeave.from_date)} — {formatDateVN(selectedLeave.to_date)}
                      </span>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-white border border-gray-50 rounded-2xl">
                      <div className="flex items-center gap-3 min-w-0">
                        <div className="p-2 rounded-xl bg-amber-50 text-amber-600">
                          <FontAwesomeIcon icon={faClock} />
                        </div>
                        <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
                          Loại nghỉ / Số ngày
                        </span>
                      </div>
                      <span className="text-sm font-black text-gray-700 sm:text-right break-words">
                        {selectedLeave.leave_type || "-"} • {selectedLeave.total_days || 0} ngày
                      </span>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <h5 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] ml-2">
                      Lý do nghỉ
                    </h5>
                    <div className="p-5 bg-amber-50/30 border border-amber-100/50 rounded-3xl">
                      <p className="text-sm text-amber-900 font-bold italic leading-relaxed">
                        "{selectedLeave.reason || "Không có lý do"}"
                      </p>
                    </div>
                  </div>

                  <div className="border border-slate-100 rounded-3xl bg-slate-50 p-4">
                    <h5 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-3">
                      Lịch sử phê duyệt
                    </h5>

                    {timeline.length === 0 ? (
                      <p className="text-sm text-gray-500 italic">Chưa có lịch sử.</p>
                    ) : (
                      <div className="space-y-2">
                        {timeline.map((t, i) => (
                          <div
                            key={i}
                            className="bg-white rounded-2xl border border-slate-100 p-3"
                          >
                            <p className="text-xs font-black uppercase tracking-wide text-slate-500">
                              Cấp {t.level} - {t.actor_name} ({t.actor_position || "N/A"})
                            </p>
                            <p className="text-sm font-semibold text-gray-700 mt-1">
                              {t.action} - {t.note || "Không ghi chú"}
                            </p>
                            <p className="text-[11px] text-gray-400 mt-1">{t.created_at}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {canApprove ? (
                    <div className="space-y-3">
                      <textarea
                        className="w-full bg-slate-50 border border-slate-100 rounded-[1.2rem] p-4 text-sm font-bold text-gray-700 outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-200 focus:bg-white transition-all placeholder:font-medium placeholder:text-gray-300"
                        rows={3}
                        placeholder="Ghi chú duyệt / từ chối (bắt buộc khi từ chối)"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                      />
                      <div className="flex flex-col sm:flex-row gap-3">
                        <button
                          className="flex-1 px-6 py-3.5 border border-rose-100 text-rose-600 rounded-2xl font-black text-[11px] uppercase tracking-widest bg-rose-50 hover:bg-rose-100 transition-all flex items-center justify-center gap-2"
                          onClick={handleReject}
                        >
                          <FontAwesomeIcon icon={faXmark} /> Không duyệt
                        </button>
                        <button
                          className="flex-1 px-6 py-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-black text-[11px] uppercase tracking-[0.15em] rounded-2xl flex items-center justify-center gap-2 shadow-lg shadow-emerald-100 transition-all active:scale-95"
                          onClick={handleApprove}
                        >
                          <FontAwesomeIcon icon={faCheck} /> Duyệt phiếu
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 rounded-xl bg-slate-50 border border-slate-100 text-sm text-gray-500 font-semibold">
                      Bạn không phải người duyệt cấp hiện tại.
                    </div>
                  )}
                </div>

                <div className="px-4 sm:px-8 pb-4 sm:pb-8 pt-0 flex justify-end shrink-0">
                  <button
                    className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-2xl font-black text-[11px] uppercase tracking-widest transition-all"
                    onClick={closeModal}
                  >
                    Đóng
                  </button>
                </div>
              </motion.div>
            </motion.div>
            )}
        </AnimatePresence>
    </>
  );
}
